import { Grid, Skeleton } from '@mui/material';
import LabelledDropdown from 'components/atoms/Dropdown/LabelledDropdown';
import { map, uniqBy } from 'lodash';
import React, { FunctionComponent } from 'react';
import { useCurrentLabUsers } from 'utils/useCurrentLabUsers';
import { useCurrentUser } from 'utils/useCurrentUser';

interface StudyAdminProps {
  presetStudyAdmin?: string;
  onChange: (value: string) => void;
  studyId?: string;
}

const StudyAdmin: FunctionComponent<React.PropsWithChildren<StudyAdminProps>> = ({
  presetStudyAdmin = '',
  onChange,
  studyId,
}) => {
  const [studyAdmin, setStudyAdmin] = React.useState<string>(presetStudyAdmin);

  const currentUserProfile = useCurrentUser();
  const currentUser = { value: currentUserProfile.userId, text: currentUserProfile.userName };
  const { data: labUserProfiles, isLoading: isLoadingUserCredentials } = useCurrentLabUsers(studyId);
  const labUsers = uniqBy(
    [
      ...map(labUserProfiles?.users, (user) => ({
        value: user.id,
        text: user.primaryEmail,
      })),
      currentUser,
    ],
    'value'
  );

  return (
    <Grid item container direction="column" spacing={1}>
      <Grid item>
        {isLoadingUserCredentials ? (
          <Skeleton variant="rectangular" width={'100%'} height={43.56} />
        ) : (
          <LabelledDropdown
            size="small"
            variant="outlined"
            label="Study Administrator"
            options={labUsers}
            value={studyAdmin}
            onOptionSelected={(value) => {
              setStudyAdmin(value);
              onChange(value);
            }}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default StudyAdmin;
